import { history } from '../redux/store';

export function navegarABandeja() {
  history.push({pathname:'/vertical/bandeja-fichas'});
}